import { render, staticRenderFns } from "./session-settings.vue?vue&type=template&id=50a0fb7b&"
import script from "./session-settings.vue?vue&type=script&lang=ts&"
export * from "./session-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports